// Generated by CoffeeScript 1.11.1
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_form',['require','backbone','underscore','../../validator'],function(require) {
  var QuestionForm, Validator, View, _;
  View = require("backbone").View;
  _ = require('underscore');
  Validator = require('../../validator');
  return QuestionForm = (function(superClass) {
    extend(QuestionForm, superClass);

    function QuestionForm() {
      return QuestionForm.__super__.constructor.apply(this, arguments);
    }

    QuestionForm.UPDATE_EVENT = 'update';

    QuestionForm.prototype.values = null;

    QuestionForm.prototype.definitions = null;

    QuestionForm.prototype.initialize = function(options) {
      return this.values = [];
    };

    QuestionForm.prototype.render = function() {
      return this.$el.empty();
    };

    QuestionForm.prototype.randomize = function() {
      var getRandom, inputItems, shuffled;
      inputItems = this.$el.children("li");
      getRandom = function(max) {
        return Math.floor(Math.random() * max);
      };
      shuffled = $.map(inputItems, function() {
        var randItem, random;
        random = getRandom(inputItems.length);
        randItem = $(inputItems[random]).clone(true)[0];
        inputItems.splice(random, 1);
        return randItem;
      });
      return this.$el.children("li").each(function(i) {
        return $(this).replaceWith($(shuffled[i]));
      });
    };

    QuestionForm.prototype.setLayout = function() {
      var fnc;
      fnc = function(index, css) {
        if (css) {
          return (css.match(/(^|\s)layout-\S+/g) || []).join(' ');
        }
      };
      return this.$el.removeClass(fnc).addClass("layout-" + (this.model.get('properties').layout));
    };

    QuestionForm.prototype.setValues = function(vals) {
      if (vals == null) {
        vals = this.values;
      }
      if (!_.isArray(vals) || !vals.length) {

      }
    };

    QuestionForm.prototype.update = function() {
      return this.trigger(QuestionForm.UPDATE_EVENT);
    };

    QuestionForm.prototype.valid = function() {
      return !this.model.get('required');
    };

    QuestionForm.prototype.validate = function() {
      var args, errors, props, required, uniqVals, validator;
      required = this.model.get('required');
      props = this.model.get('properties');
      if (_.isEmpty(this.values) && !required) {
        return null;
      }
      if (required && _.isEmpty(this.values)) {
        return this.definitions.validations["default"];
      }
      switch (this.model.get('type')) {
        case "multiple_choice":
        case "image":
          if (props.multi) {
            if (props.min && this.values.length < props.min) {
              return this.definitions.validations.selectMin.replace("%s", props.min);
            }
            if (props.max && this.values.length > props.max) {
              return this.definitions.validations.selectMax.replace("%s", props.max);
            }
          }
          break;
        case "essay":
          if (props.min && this.values[0].length < Number(props.min)) {
            return this.definitions.validations.minLength.replace(/%s\s/, "").replace("%s", props.min);
          }
          if (props.max && this.values[0].length > Number(props.max)) {
            return this.definitions.validations.maxLength.replace(/%s\s/, "").replace("%s", props.max);
          }
          break;
        case "scale":
          if (!$.isNumeric(this.values[0])) {
            return this.definitions.validations.numeric.replace("%s", this.definitions.scaleMin);
          }
          this.values[0] = Number(this.values[0]);
          if (this.values[0] < Number(props.min)) {
            return this.definitions.validations.greaterThan.replace("%s", this.definitions.scaleMin).replace("%s", props.min);
          }
          if (this.values[0] > Number(props.max)) {
            return this.definitions.validations.lessThan.replace("%s", this.definitions.scaleMin).replace("%s", props.max);
          }
          break;
        case "range":
          if (!$.isNumeric(this.values[0])) {
            return this.definitions.validations.numeric.replace("%s", this.definitions.rangeMin);
          }
          if (!$.isNumeric(this.values[1])) {
            return this.definitions.validations.numeric.replace("%s", this.definitions.rangeMax);
          }
          this.values[0] = Number(this.values[0]);
          this.values[1] = Number(this.values[1]);
          if (this.values[0] >= this.values[1]) {
            return this.definitions.validations.greaterThan.replace("%s", this.definitions.rangeMin).replace("%s", this.values[1] - 1);
          }
          if (this.values[0] < Number(props.min)) {
            return this.definitions.validations.greaterThan.replace("%s", this.definitions.rangeMin).replace("%s", props.min);
          }
          if (this.values[1] > Number(props.max)) {
            return this.definitions.validations.lessThan.replace("%s", this.definitions.rangeMax).replace("%s", props.max);
          }
          break;
        case "form":
          if (props.requireAll && this.values.length < props.labels.length) {
            return this.definitions.validations.allForm;
          }
          if (props.validations) {
            args = props.validations.map((function(_this) {
              return function(item) {
                var msg, val;
                val = _.find(_this.values, {
                  label: item.label
                });
                if (_this.definitions.validations[item.rule] != null) {
                  msg = Validator.prototype.parseValidationMessage(_this.definitions.validations[item.rule], item.label, item.option);
                }
                return {
                  label: item.label,
                  rules: (item.option != null) && !_.isEmpty(String(item.option)) ? item.rule + "[" + item.option + "]" : item.rule,
                  value: val && val.value ? val.value : '',
                  message: msg
                };
              };
            })(this));
            validator = new Validator(args);
            errors = validator.validate();
            if (errors && errors.length) {
              return errors.map((function(_this) {
                return function(err, index) {
                  return err.message;
                };
              })(this));
            }
          }
          break;
        case "scoring":
          if (props.requireAll && (props.labels.length > this.values.length)) {
            return this.definitions.validations.allScore;
          }
          if (props.requireUnique) {
            uniqVals = _.chain(this.values).map("value").uniq().value();
            if (uniqVals.length !== this.values.length) {
              return this.definitions.validations.uniqueScore;
            }
          }
          break;
        case "date_time":
          if (!_.isDate(this.values[0])) {
            if (props.date && props.time) {
              return this.definitions.validations.invalidDateTime;
            }
            if (props.time) {
              return this.definitions.validations.invalidTime;
            }
            if (props.date) {
              return this.definitions.validations.invalidDate;
            }
          }
      }
      return null;
    };

    return QuestionForm;

  })(View);
});

